@if (loggedInUserService.isAuthenticated()) {
  <vectronic-header [displaySwitchApp]="true" (sidenavToggle)="sidenav.toggle()">
    <a logo [routerLink]="['/']">
      <img
        [src]="
          env.environment === 'staging' || env.environment === 'local'
            ? 'logo_horizontal_staging_v3.svg'
            : 'logo_horizontal_v2.svg'
        "
        alt="myVectronic Logo"
      />
    </a>
    <ul nav-items>
      @for (navItem of navItems; track navItem.path) {
        @if (navItem.shouldDisplay) {
          <li [class.active-route]="isActive(navItem)">
            <a [routerLink]="[navItem.path]">
              <mat-icon [class]="navItem.iconClass">{{ navItem.icon }}</mat-icon>
              <span class="nav-caption">{{ navItem.label }}</span></a
            >
          </li>
        }
      }
    </ul>
    <ng-container switchApp-dropdown>
      <a mat-menu-item [href]="env.inventaUrl">Inventa</a>
    </ng-container>

    <ng-container help-dropdown>
      <button
        mat-menu-item
        (click)="
          openInNewTab('https://www.vectronic-aerospace.com/overview-of-main-tabs-and-submenus/')
        "
      >
        Help
      </button>
      <button mat-menu-item (click)="tourGuide()">First Steps</button>
      <button mat-menu-item (click)="reportIssueModal()">Report Issue</button>
      <button
        mat-menu-item
        (click)="openInNewTab('https://www.vectronic-aerospace.com/legal-notice/')"
      >
        Legal Notice
      </button>
      <button mat-menu-item (click)="openAboutMyVectronicModal()">About My Vectronic</button>
    </ng-container>
    <ng-container account-dropdown>
      <a mat-menu-item [routerLink]="['profile']">Profile</a>
      <button mat-menu-item (click)="onLogoutBtnClicked()">Logout</button>
    </ng-container>
  </vectronic-header>
  <mat-sidenav-container>
    <mat-sidenav #sidenav>
      <mat-nav-list>
        @for (navItem of navItems; track navItem.path) {
          @if (navItem.shouldDisplay) {
            <a
              mat-list-item
              [routerLink]="[navItem.path]"
              [activated]="isActive(navItem)"
              tabindex="-1"
              ><mat-icon matListItemIcon [class]="navItem.iconClass">{{ navItem.icon }}</mat-icon
              ><span MatListItemTitle>{{ navItem.label }}</span></a
            >
          }
        }
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <main>
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
}
